/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnergyUsageCredentialsRequest } from '../models/EnergyUsageCredentialsRequest';
import type { EnergyUsageCredentialsResponse } from '../models/EnergyUsageCredentialsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnergyUsagesRoutesRepository {
  /**
   * Store Utility Credentials
   * Create energy usage credentials.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static energyUsagesRoutesStoreUtilityCredentials({
    requestBody,
    authorization,
  }: {
    requestBody: EnergyUsageCredentialsRequest,
    authorization?: string,
  }): CancelablePromise<(EnergyUsageCredentialsResponse | null)> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/energy-usages/credentials',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
